import algoliasearch from "algoliasearch";
const algo = algoliasearch("ORJGVCCGN1", "15a46d258d08af1a7b0193342ad90568");
const ind = algo.initIndex("hymns_index");

export const algolia = algolia
export const index = ind